import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Mobile bottom tab bar — the phone-first primary nav. Four modes flank a
// prominent center mic (voice logging is the core loop). Desktop uses the
// sidebar instead; this is hidden at md+.

const HomeIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" />
  </svg>
);
const YouIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="8" r="3.5" /><path d="M5 20c0-3.5 3-6 7-6s7 2.5 7 6" />
  </svg>
);
const DataIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M4 20V4" /><path d="M4 20h16" /><path d="M8 16l4-6 3 3 5-8" />
  </svg>
);
const InsightsIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M12 3v2M12 19v2M5 12H3m18 0h-2M6 6 4.5 4.5M18 6l1.5-1.5" /><circle cx="12" cy="12" r="4" />
  </svg>
);

const Tab = ({ to, label, Icon, active }) => (
  <Link
    to={to}
    className={`flex flex-col items-center justify-start gap-1 pt-1.5 text-xs font-semibold transition-colors ${
      active
        ? 'text-primary-600 dark:text-primary-400'
        : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
    }`}
  >
    <Icon className={`w-6 h-6 ${active ? 'solar-glow' : ''}`} />
    {label}
  </Link>
);

const BottomNav = () => {
  const { pathname } = useLocation();
  const is = (p) => pathname === p;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 h-[84px] px-2 pt-2
                 grid grid-cols-5 items-start
                 bg-surface-card/95 dark:bg-black/95 backdrop-blur
                 border-t border-surface-border dark:border-surface-dark-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      <Tab to="/home" label="Home" Icon={HomeIcon} active={is('/home')} />
      <Tab to="/you" label="You" Icon={YouIcon} active={is('/you')} />

      {/* Center mic — the voice-logging hero action */}
      <div className="flex justify-center">
        <Link
          to="/log"
          aria-label="Log"
          className="-mt-6 w-14 h-14 rounded-full bg-solar-gradient shadow-glow
                     flex items-center justify-center text-[#170f02] font-bold text-base tracking-tight
                     border-4 border-surface-card dark:border-black"
        >
          Log
        </Link>
      </div>

      <Tab to="/data" label="Data" Icon={DataIcon} active={is('/data')} />
      <Tab to="/insights" label="Insights" Icon={InsightsIcon} active={is('/insights')} />
    </nav>
  );
};

export default BottomNav;
